import React, { useContext, useEffect } from 'react'
import './ContactUs.css'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useHistory } from 'react-router-dom'
import { mapData, handleRedirectInternal } from '../../../Product/common/components'
import PrimaryButton from '../../../Product/components/atoms/PrimaryButton'
import AuthContext from '../../../Product/context/auth/authContext'
import UserContext from '../../../Product/context/user/userContext'
import Layout from '../Layout'
import { useTranslation } from 'react-i18next'

function ContactUs() {
    const authContext = useContext(AuthContext)
    const userContext = useContext(UserContext)
    const { send_contactus, responseStatus } = userContext
    const { user, loadUser } = authContext
    const history = useHistory()
    const contactEmail = global?.storeDetails?.contact_email
    const contactPhone = global?.storeDetails?.phone
    const contactAddress = global?.storeDetails?.address
    const { t } = useTranslation()
    const validationArray = Yup.object({
        name: Yup.string()
            .trim()
            .matches(/^[a-zA-Z ]*$/g, 'Special characters not allowed')
            .max(15, 'Maximum 15 characters')
            .required(t('required')),

        from_email: Yup.string().email('Invalid email format').required(t('required')),
        phone_number: Yup.string()
            .trim()
            .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
            .min(17, 'Invalid!')
            .max(21, 'Maximum 14 digits')
            .required(t('required')),
        subject: Yup.string().required(t('required')),
        messages: Yup.string().required(t('required')),
    })

    const formik = useFormik({
        initialValues: {
            name: '',
            last_name: '',
            from_email: '',
            phone_number: '',
            subject: '',
            messages: '',
            is_send_email: 1,
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            send_contactus(values)
        },
    })

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'send_contactus') {
                if (responseStatus.status === 'success') {
                    handleRedirectInternal(history, '')
                }
            }
        }
    }, [responseStatus])

    const contactInfo = [
        {
            label: t('name'),
            name: 'name',
            type: 'text',
            placeholder: t('enter_first'),
            class: 'col-sm-6 col-12',
            autoFocus: true,
            formik: formik,
        },

        {
            label: t('email'),
            name: 'from_email',
            type: 'text',
            placeholder: t('enter_email'),
            class: 'col-sm-6 col-12',
            formik: formik,
        },
        {
            label: t('Phone Number'),
            name: 'phone_number',
            type: 'phone',
            placeholder: 'Enter your phone number',
            class: 'col-sm-6 col-12',
            formik: formik,
            enableLongNumbers: 1,
        },
        // {
        //     label: 'Subject',
        //     name: 'subject',
        //     type: 'text',
        //     placeholder: 'Enter your subject',
        //     class: 'col-12',
        //     formik: formik,
        // },
        {
            label: t('Message'),
            name: 'messages',
            type: 'textarea',
            placeholder: 'Enter your message',
            class: 'col-12',
            formik: formik,
        },
    ]
    useEffect(() => {
        loadUser()
    }, [])

    useEffect(() => {
        if (user) {
            formik.values.name = user?.first_name + ' ' + user?.last_name || ''
            formik.values.phone_number = user?.phone_number || ''
            formik.values.from_email = user?.email || ''
            formik.values.subject = 'General Enquiry'
        }
    }, [user])

    return (
        <Layout>
            <div className="contact-main-container">
                <div className="container">
                    <div className="main-contact">
                        <div className="page-width">
                            <div className="grid">
                                <div className="grid-item">
                                    <div className="section-header text-center">
                                        <h1 className="font-weight-bold">Contact Us</h1>
                                    </div>
                                    <div className="rte">
                                        <div className="text-center mb-3">
                                            Feel free to email me directly at sales@lotofcards.com
                                            or reach out on Facebook Messenger. Filling out the form
                                            below works as well.
                                        </div>
                                        <div className="text-center mb-3">Phone 603-557-5919</div>
                                        <div className="text-center mb-3">
                                            <div className="mb-4">
                                                This is Grant Kush who works with Lot of Cards
                                                heading up our Marketing and Sales efforts.You can
                                                reach him at Grant@lotofcards.com
                                            </div>
                                            <img
                                                src="https://forwardapidev.auctionsoftware.com/uploads/product/bf8df1775fff69b91130fe79ac2928ce.webp"
                                                height="100%"
                                                width="100%"
                                                alt="contact-image"
                                                className="contact-me-cal"
                                            />
                                        </div>
                                    </div>
                                    <div className="contactform">
                                        <div className="text-center scontact-us-wrap flex-btnscol">
                                            <form onSubmit={formik.handleSubmit}>
                                                <div className="row">
                                                    {Object.values(mapData(contactInfo))}
                                                    <div className="col-12">
                                                        <PrimaryButton
                                                            label={t('submit')}
                                                            type="submit"
                                                        />
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="contact-banner">
                    <img src="/assets/images/contact_us.png" alt="" />
                </div>
                <div className="container cu-margin-125">
                    <div className="row">
                        <div className="col-xs-12 col-md-8 padtop">
                            <div className="contactform">
                                <div className="cu-head">{t('contact_us')}</div>
                                <div className="text-center scontact-us-wrap flex-btnscol">
                                    <form onSubmit={formik.handleSubmit}>
                                        <div className="row">
                                            {Object.values(mapData(contactInfo))}
                                            <div className="col-12">
                                                <PrimaryButton label={t('submit')} type="submit" />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-4 padtop">
                            <div className="contactform cfRt">
                                <div className="cu-head">Reach Us</div>
                                {contactAddress && contactAddress != 'null' && (
                                    <div className="media">
                                        <div className="media-left">
                                            <span className="material-icons">location_on</span>
                                        </div>
                                        <div className="media-body">
                                            <h5 className="ru-head">Address</h5>
                                            <span className="ru-con">{contactAddress}</span>
                                        </div>
                                    </div>
                                )}
                                {contactEmail && (
                                    <div className="media">
                                        <div className="media-left">
                                            <span className="material-icons">mail</span>
                                        </div>
                                        <div className="media-body">
                                            <h5 className="ru-head">{t('email_address')}</h5>
                                            <a href={`mailto:${contactEmail}`} className="ru-con">
                                                {contactEmail}
                                            </a>
                                        </div>
                                    </div>
                                )}
                                {contactPhone && (
                                    <div className="media">
                                        <div className="media-left">
                                            <span className="material-icons">call</span>
                                        </div>
                                        <div className="media-body">
                                            <h5 className="ru-head">Call</h5>
                                            <a href={`tel:${contactPhone}`} className="ru-con">
                                                <span dir="ltr">{contactPhone}</span>
                                            </a>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        </Layout>
    )
}

export default ContactUs
